import React, { useEffect } from 'react';

// Google Customer Reviews — seller rating badge (floating widget).
//
// Loads Google's merchant widget once and starts it with the store's Merchant
// Center ID. Once Google has collected enough reviews to assign a store
// rating, the badge floats in the corner of the page showing your 1–5 stars.
// Rendered from the site footer so it appears on every page.

const MERCHANT_ID = '5685452191';

export default function GoogleReviewsBadge() {
  useEffect(() => {
    if (document.getElementById('gcr-merchant-widget')) return;

    const script = document.createElement('script');
    script.id = 'gcr-merchant-widget';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.defer = true;
    script.addEventListener('load', () => {
      try {
        window.merchantwidget?.start?.({
          merchant_id: MERCHANT_ID,
          position: 'BOTTOM_RIGHT',
          region: 'GB',
        });
      } catch (_) {}
    });
    document.body.appendChild(script);
  }, []);

  // Google injects the floating badge itself — no container needed.
  return null;
}